import { render, staticRenderFns } from "./CategoriasView.vue?vue&type=template&id=c81567a0&scoped=true"
import script from "./CategoriasView.vue?vue&type=script&lang=js"
export * from "./CategoriasView.vue?vue&type=script&lang=js"
import style0 from "./CategoriasView.vue?vue&type=style&index=0&id=c81567a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81567a0",
  null
  
)

export default component.exports